import { FC, useMemo } from "react";

import { EditGARTask } from "@nens/brostar/uploadapi-client";

import { getApi } from "@/api/api-configuration";
import { getFormObjectValues } from "@/helpers/helpers";
import { useAfterFormSubmit } from "@/hooks/use-after-form-submit";
import { BrostarForm, useBrostarFormDataStorage } from "@/libs/brostar-form";
import { EditGarFormProps } from "@/types/form-types";

import { getEditGarSchema } from "./schema/gar-schema";
import { garUiSchema } from "./schema/gar-ui-schema";

const EditGarForm: FC<EditGarFormProps> = (props) => {
  const api = getApi();
  const afterSubmit = useAfterFormSubmit();

  const { type, oldUploadTask, task } = getFormObjectValues(props);

  const { formData, handleChange } = useBrostarFormDataStorage<EditGARTask>({
    key: "gar",
    task,
  });

  const garSchema = useMemo(() => getEditGarSchema({ type }), [type]);

  const onSubmit = async () => {
    if (!formData) return;
    await api.editGar(formData);
    if (oldUploadTask && oldUploadTask.uuid) api.apiUploadtasksDelete({ uuid: oldUploadTask.uuid });
    await afterSubmit();
  };

  return (
    <BrostarForm<EditGARTask>
      schema={garSchema}
      uiSchema={garUiSchema}
      onSubmit={onSubmit}
      uploadTask={oldUploadTask}
      formData={formData}
      onChange={handleChange}
    />
  );
};

export { EditGarForm };
